import * as React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import styled from '@emotion/styled';

import Icons from '../../../themes/icons';

type TitleWithDescriptionProps = {
  title: string;
};

export const ManageContentTipsV2: React.FC = () => (
  <Box>
    <Typography fontSize={'20px'} fontWeight={500}>
      What is content?
    </Typography>
    <Stack spacing={5} paddingY='42px' paddingX='12px'>
      <Box
        display={'flex'}
        alignItems={'center'}
        sx={{ borderBottom: '1px solid #EBEBEB', gap: '22px', paddingBottom: '48px' }}
      >
        <Box minWidth={'16%'} textAlign={'center'}>
          <Icons.PostContentIcon />
        </Box>
        <Box px={3}>
          <Typography fontSize={'18px'} fontWeight={500}>
            Posts
          </Typography>
          <Typography fontSize={'15px'} fontWeight={300} textAlign={'left'}>
            In this section you can find the posts our members publish on social media to promote
            your business.
          </Typography>
        </Box>
      </Box>
      <Stack spacing={7}>
        <Box display={'flex'} alignItems={'center'} sx={{ gap: '22px' }}>
          <Box minWidth={'16%'} textAlign={'center'}>
            <Icons.ExtraContentIcon />
          </Box>
          <Box px={3}>
            <Typography fontSize={'18px'} fontWeight={500}>
              Extra Content
            </Typography>
            <Typography fontSize={'15px'} fontWeight={300} textAlign={'left'}>
              Content that members upload <b>in addition</b> to the post and that you can purchase
              and use to promote your business.
            </Typography>
          </Box>
        </Box>
        <Box display={'flex'} alignItems={'center'} sx={{ gap: '22px' }}>
          <Box minWidth={'16%'} textAlign={'center'}>
            <Icons.UsageRightsIcon />
          </Box>
          <Box px={3}>
            <Typography fontSize={'18px'} fontWeight={500}>
              Purchased Content
            </Typography>
            <Typography fontSize={'15px'} fontWeight={300} textAlign={'left'}>
              You have the right to use <b>purchased content</b> worldwide for 90 days from the date of
              purchase. The creator retains ownership.
            </Typography>
          </Box>
        </Box>
      </Stack>
    </Stack>
  </Box>
);

const Title = styled.h6`
  font-size: 20px;
  font-weight: 600;
  color: #111111;
  margin: 0 0 8px 0;
`;
